module.exports = __webpack_public_path__ + "static/media/Benchmark.ec594c71.svg";